import React, { useState, useId } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard } from '@fortawesome/free-regular-svg-icons';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const CopyToClipboardButton = ({ textToCopy }) => {
    const [copied, setCopied] = useState(false);
    const tooltipId = useId();

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopied(true);
            setTimeout(() => setCopied(false), 3000); // Reset copied status after 3 seconds
        } catch (err) {
            // Handle the error case
        }
    };

    const renderTooltip = (props) => (
        <Tooltip id={tooltipId} {...props}>
            {copied ? 'Copied!' : `Copy ${textToCopy} to clipboard`}
        </Tooltip>
    );

  return (
    <OverlayTrigger
      placement="top"
      overlay={renderTooltip}
    >
      <button
        type="button"
        onClick={copyToClipboard}
        aria-label={copied ? "Copied to clipboard" : `Copy ${textToCopy} to clipboard`}
        style={{ cursor: "pointer", marginLeft: "5px", border: "none", background: "none", padding: 0 }}
      >
        <FontAwesomeIcon icon={faClipboard} aria-hidden="true" />
      </button>
    </OverlayTrigger>
  );
};

export default CopyToClipboardButton;
